import { useState, type FormEvent, type ReactNode } from 'react';
import { IconNota } from '@fa/ui';
import { ApiError, api, setToken } from './lib/api.js';

/**
 * Entrada no portal.
 *
 * Uma mensagem so para e-mail inexistente e senha errada — dizer qual dos dois
 * falhou entrega ao atacante a lista de contas que existem.
 */
export function Login({ onSignedIn }: { onSignedIn: () => void }): ReactNode {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await api<{ token: string }>('/v1/auth/login', {
        method: 'POST',
        body: { email, password },
      });
      setToken(result.token);
      onSignedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Nao foi possivel entrar. Tente novamente.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <form
        onSubmit={submit}
        className="card"
        style={{ width: 'min(400px, 100%)', padding: 32, display: 'grid', gap: 18 }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 700, fontSize: '1.05rem' }}>
          <i className="marca">
            <IconNota />
          </i>
          FA Tech Notas
        </div>

        <div>
          <h1 style={{ fontSize: '1.3rem', letterSpacing: '-.02em' }}>Entrar no portal</h1>
          <p style={{ color: 'var(--ink-3)', marginTop: 4 }}>
            Acompanhe suas notas, emitentes e integrações.
          </p>
        </div>

        {error && (
          <div className="alert bad">
            <b>Não foi possível entrar</b>
            {error}
          </div>
        )}

        <label style={{ display: 'grid', gap: 6 }}>
          <span style={{ fontSize: '.85rem', color: 'var(--ink-2)', fontWeight: 600 }}>E-mail</span>
          <input
            className="input"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@empresa.com.br"
          />
        </label>

        <label style={{ display: 'grid', gap: 6 }}>
          <span style={{ fontSize: '.85rem', color: 'var(--ink-2)', fontWeight: 600 }}>Senha</span>
          <input
            className="input"
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        <button
          className="btn btn-primary"
          type="submit"
          disabled={busy}
          style={{ justifyContent: 'center' }}
        >
          {busy ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
